import React, { useContext, useState } from "react";
import ModalContext from "../../../Contexts/openModal";
import "../../../styles/components/Slices/LogosMonnet.scss";
import HeadingSection from "../../Pieces/HeadingSection";
import CustomButton from "../../CustomButton";
import { CloseFeature } from "../../../assets/icons/closeFeatures";
import { ShowFeature } from "../../../assets/icons/showFeatures";
import useWindowWidth from "../../../hooks/useBetterMediaQuery";
import { useLocation } from "@reach/router";

export const LogosMonet = ({ slice }) => {
  const location = useLocation();
  const aboutUs = location?.pathname === "/about-us/";
  const customers =
    location?.pathname === "/customers/" || location?.pathname === "/demo/";
  const { toggleModal } = useContext(ModalContext);

  const [showMoreLogos, setShowMoreLogos] = useState(false);
  const isTablet = useWindowWidth(640);
  const isMobile = useWindowWidth(420);
  const isDesktop = useWindowWidth(1023);
  const isLargeDesktop = useWindowWidth(1240);
  const ShowLogos = () => {
    setShowMoreLogos(!showMoreLogos);
  };
  const topSpacing = slice?.primary?.top_spacing;
  const bottomSpacing = slice?.primary?.bottom_spacing;

  return (
    <section className="relative px-4 mx-auto sm:px-12 lg:px-5 max-w-7xl">
      <article
        className={` lg:mx-11 ${topSpacing === "80" ? "sm:pt-20 pt-8" : topSpacing === "40" ? "sm:pt-10 pt-8" : topSpacing === "0" ? "pt-0" : "pt-8 lg:pt-10"}  ${bottomSpacing === "80" ? "sm:pb-20 pb-8" : bottomSpacing === "40" ? "sm:pb-10 pb-8" : bottomSpacing === "0" ? "pb-0" : "pb-8 lg:pb-10"}`}
      >
        {(slice?.primary?.title?.text ||
          slice?.primary?.descriptor_text?.text) && (
          <HeadingSection
            data={slice?.primary}
            toggleModal={toggleModal}
            sectionStyle="sm:max-w-[648px] tracking-[-0.45px] md:max-w-[1002px] lg:!pb-10"
            descriptionStyle={`${aboutUs ? "!text-[#262626] font-manrope font-semibold text-xl sm:text-2xl tracking-tightest_5" : "lg:text-lg custom_line_height lg:tracking-tighter_1 "}`}
            textAreaStyle="gap-4"
            headingStyle={`sm:text-3.25xl ${customers && "text-purple-1100"}  sm:leading-10 sm:!-tracking-[0.9px]`}
          />
        )}
        {aboutUs ? (
          <div className="grid flex-wrap justify-center max-w-2xl grid-cols-2 gap-5 mx-auto sm:grid-cols-3 ">
            {slice?.items?.map((value, index) => {
              const content = (
                <div className="flex justify-center items-center min-h-18 max-h-18 lg:max-h-[100px] lg:min-h-[100px] w-full">
                  <img
                    className="!object-scale-down max-w-[100px] xs:max-w-[178px] max-h-[72px]  xs:min-h-[81px] xs:max-h-[81px]"
                    src={value?.image?.url}
                    alt={value?.image?.alt || "company logo"}
                  />
                </div>
              );
              return (
                <div key={index}>
                  {value.logo_link?.url ? (
                    <a
                      href={value.logo_link?.url}
                      target="_blank"
                      aria-label="opens in a new tab"
                      className="cursor-pointer"
                      rel="noopener noreferrer"
                    >
                      {content}
                    </a>
                  ) : (
                    content
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div
            style={{
              // overflow: "hidden",
              maxHeight: showMoreLogos
                ? "2000px"
                : isTablet
                  ? "670px"
                  : isMobile
                    ? "557px"
                    : "435PX",

              transition: "max-height 0.8s ease-in-out",
              opacity: 1,
            }}
            className={`grid grid-cols-2 smx:grid-cols-3 sm-grid-screen lg:grid-cols-10 xl:grid-cols-6 gap-3 sm:gap-5 p-3 lg:p-0 overflow-hidden lg:overflow-visible transition-all ease-in-out duration-500`}
          >
            {slice?.items?.map((value, index) => {
              const totalItems = slice.items.length;
              const itemsPerRow = isLargeDesktop
                ? 6
                : isDesktop
                  ? 5
                  : isTablet
                    ? 3
                    : "";
              const itemsInLastRow = totalItems % itemsPerRow;
              const isLastRow = index >= totalItems - itemsInLastRow;
              let colStartClass = "";
              if (isLastRow && itemsInLastRow !== 0) {
                const startMap = {
                  1: "sm:col-start-2",
                  2: "lg:col-start-4 ",
                  3: "xl:col-start-3",
                  4: "xl:col-start-2",
                  // 5: "lg:col-start-2",
                };
                if (index === totalItems - itemsInLastRow) {
                  colStartClass = startMap[itemsInLastRow] || "";
                }
              }
              const content = (
                <div
                  className={`flex justify-center items-center rounded-[10px] h-[73px] xs:h-[97px] sm:h-[112.5px] lg:h-[82px] xl:h-[97px] w-full`}
                >
                  <img
                    className={`${slice?.primary?.show_gray_scale && "grayscale"} ${customers && "grayscale"} object-scale-down w-full h-full p-2 sm:p-4`}
                    src={value?.image?.url}
                    alt={value?.image?.alt || "company logo"}
                  />
                </div>
              );

              return (
                <>
                  <div
                    key={index}
                    className={`mx-auto lg:col-span-2 xl:col-span-1 w-full ${colStartClass}`}
                  >
                    {value.logo_link?.url ? (
                      <a
                        href={value.logo_link?.url}
                        target="_blank"
                        aria-label="opens in a new tab"
                        className="cursor-pointer"
                        rel="noopener noreferrer"
                      >
                        {content}
                      </a>
                    ) : (
                      content
                    )}
                  </div>
                </>
              );
            })}
          </div>
        )}
        <div
          className={`${aboutUs ? "hidden" : "flex lg:hidden justify-center mt-6"}`}
        >
          <CustomButton
            text={showMoreLogos ? "Show less" : "Show more"}
            icon={showMoreLogos ? <CloseFeature /> : <ShowFeature />}
            buttonClass="text-gray-2500 hover:text-gray-2700 hover:bg-gray-1600 sm:text-lg mx-auto border border-gray-2200"
            direction={showMoreLogos ? "top" : "bottom"}
            onClick={ShowLogos}
          />
        </div>
      </article>
    </section>
  );
};
